<!-- Section Pompe -->
<app-collapse [title]="'P0003600.parameters.status.rubrique.pompe' | translate">
  <div slot="contenu">
    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="'P0003600.parameters.status.statut.etatDeLaPompe' | translate"
        [value]="getValue('fsSEtatPompe') !== 0"
      />
    }

    <app-display-rubrique-status
      [title]="
        'P0003600.parameters.status.statut.courantConsommeParLaPompe'
          | translate
      "
      [value]="(getValue('fsSCourantConsomePompe') / 10).toFixed(1) + ' A'"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.detectiondeFonctionnementDeLaPompe'
            | translate
        "
        [value]="getValue('fsSDetectionFonctionnementPompe') !== 0"
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.puissanceApparente' | translate
        "
        [value]="getValue('fsSPuissanceApparente') + ' VA'"
      />
    }

    <app-display-rubrique-status
      [title]="'P0003600.parameters.status.statut.puissanceActive' | translate"
      [value]="getValue('fsSPuissanceActive') + ' W'"
    />
  </div>
</app-collapse>

<!-- Section Programme PP -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003600.parameters.status.rubrique.programmePP' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeDeFiltrationPPH' | translate
        "
        [value]="
          getValue('fsSPompeFiltrationPilotePPH') === 0
            ? ('P0003600.parameters.status.statut.pompeDeFiltrationPPH.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeDeFiltrationPPH.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeDeFiltrationPPE' | translate
        "
        [value]="
          getValue('fsSPompeFiltrationPilotePPE') === 0
            ? ('P0003600.parameters.status.statut.pompeDeFiltrationPPE.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeDeFiltrationPPE.oui'
              | translate)
        "
      />
    </div>
  </app-collapse>
}

<!-- Section Programme 72H -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003600.parameters.status.rubrique.programme72H' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeDeFiltration72H' | translate
        "
        [value]="
          getValue('fsSPompeFiltrationPilote72H') === 0
            ? ('P0003600.parameters.status.statut.pompeDeFiltration72H.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeDeFiltration72H.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.compteAReboursEnSeconde72H'
            | translate
        "
        [value]="convertSecondsToTime(getValue('fsSCompteARebours72H'))"
      />
    </div>
  </app-collapse>
}

<!-- Section Programme PU1 -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003600.parameters.status.rubrique.programmePU1' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeDeFiltrationPU1' | translate
        "
        [value]="
          getValue('fsSPompeFiltrationPiloteUsine1') === 0
            ? ('P0003600.parameters.status.statut.pompeDeFiltrationPU1.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeDeFiltrationPU1.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.dureeDeFiltrationEnMinutesPU1'
            | translate
        "
        [value]="
          convertMinutesToTime(getValue('fsSDureeFiltrationMinuteUsine1'))
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.heureArretEnMinutesPU1' | translate
        "
        [value]="convertMinutesToTime(getValue('fsSHeureArretMinuteUsine1'))"
      />
    </div>
  </app-collapse>
}

<!-- Section Programme PU2 -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003600.parameters.status.rubrique.programmePU2' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeDeFiltrationPU2' | translate
        "
        [value]="
          getValue('fsSPompeFiltrationPiloteUsine2') === 0
            ? ('P0003600.parameters.status.statut.pompeDeFiltrationPU2.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeDeFiltrationPU2.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.dureeDeFiltrationEnMinutesPU2'
            | translate
        "
        [value]="
          convertMinutesToTime(getValue('fsSDureeFiltrationMinuteUsine2'))
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.heureArretEnMinutesPU2' | translate
        "
        [value]="convertMinutesToTime(getValue('fsSHeureArretMinuteUsine2'))"
      />
    </div>
  </app-collapse>
}

<!-- Section Programme PU3 -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003600.parameters.status.rubrique.programmePU3' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeDeFiltrationPU3' | translate
        "
        [value]="
          getValue('fsSPompeFiltrationPiloteUsine3') === 0
            ? ('P0003600.parameters.status.statut.pompeDeFiltrationPU3.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeDeFiltrationPU3.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.dureeDeFiltrationEnMinutesPU3'
            | translate
        "
        [value]="
          convertMinutesToTime(getValue('fsSDureeFiltrationMinuteUsine3'))
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.heureArretEnMinutesPU3' | translate
        "
        [value]="convertMinutesToTime(getValue('fsSHeureArretMinuteUsine3'))"
      />
    </div>
  </app-collapse>
}

<!-- Section Programme Loi d'Eau -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003600.parameters.status.rubrique.programmeLoiDEau' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.mesureTemperatureLoiDEau'
            | translate
        "
        [value]="getTemperature(getValue('fsSMesureTemperatureLoiDEau') / 10)"
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.dureeFiltrationMinuteLoiDEau'
            | translate
        "
        [value]="
          convertMinutesToTime(getValue('fsSDureeFiltrationMinuteLoiDEau'))
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.heureArretEnMinutesLoiDEau'
            | translate
        "
        [value]="convertMinutesToTime(getValue('fsSHeureArretMinuteLoiDEau'))"
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.temperatureReferenceDisponibleLoiDEau'
            | translate
        "
        [value]="
          getValue('fsSTemperatureReferenceDisponibleLoiDEau') === 0
            ? ('P0003600.parameters.status.statut.temperatureReferenceDisponibleLoiDEau.non'
              | translate)
            : ('P0003600.parameters.status.statut.temperatureReferenceDisponibleLoiDEau.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeFiltrationPiloteLoiDEau'
            | translate
        "
        [value]="
          getValue('fsSPompeFiltrationPiloteLoiDEau') === 0
            ? ('P0003600.parameters.status.statut.pompeFiltrationPiloteLoiDEau.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeFiltrationPiloteLoiDEau.oui'
              | translate)
        "
      />
    </div>
  </app-collapse>
}

<!-- Section Fonction Hors Gel -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003600.parameters.status.rubrique.fonctionHorsGel' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.temperatureReferenceDisponibleHorsGel'
            | translate
        "
        [value]="
          getValue('fsSTemperatureReferenceDisponibleHorsGel') === 0
            ? ('P0003600.parameters.status.statut.temperatureReferenceDisponibleHorsGel.non'
              | translate)
            : ('P0003600.parameters.status.statut.temperatureReferenceDisponibleHorsGel.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeFiltrationPiloteHorsGel'
            | translate
        "
        [value]="
          getValue('fsSPompeFiltrationPiloteHorsGel') === 0
            ? ('P0003600.parameters.status.statut.pompeFiltrationPiloteHorsGel.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeFiltrationPiloteHorsGel.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.mesureTemperatureHorsGel'
            | translate
        "
        [value]="getTemperature(getValue('fsSMesureTemperatureHorsGel') / 10)"
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.etatFonctionHorsGel' | translate
        "
        [value]="
          P0003600EtatHorsGelEnum[getValue('fsSEtatFonctionHorsGel')].label
            | translate
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.compteAReboursEtatDiscontinu'
            | translate
        "
        [value]="
          getValue('fsSCompteAReboursEtatDiscontinu') + ('secondes' | translate)
        "
      />
    </div>
  </app-collapse>
}

<!-- Section Fonction 24/24 -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003600.parameters.status.rubrique.fonction2424' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.temperatureReferenceDisponible2424'
            | translate
        "
        [value]="
          getValue('fsSTemperatureReferenceDisponible2424') === 0
            ? ('P0003600.parameters.status.statut.temperatureReferenceDisponible2424.non'
              | translate)
            : ('P0003600.parameters.status.statut.temperatureReferenceDisponible2424.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeFiltrationPilote2424'
            | translate
        "
        [value]="
          getValue('fsSPompeFiltrationPilote2424') === 0
            ? ('P0003600.parameters.status.statut.pompeFiltrationPilote2424.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeFiltrationPilote2424.oui'
              | translate)
        "
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.mesureTemperature2424' | translate
        "
        [value]="getTemperature(getValue('fsSMesureTemperature2424') / 10)"
      />
    </div>
  </app-collapse>
}

<!-- Section Asservissements -->
@if (isSupportTechnique()) {
  <app-collapse
    [title]="'P0003600.parameters.status.rubrique.asservissements' | translate"
  >
    <div slot="contenu">
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.pompeFiltrationFonctionEntreeAsservi'
            | translate
        "
        [value]="
          getValue('fsSAsservissement') === 0
            ? ('P0003600.parameters.status.statut.pompeFiltrationPilote2424.non'
              | translate)
            : ('P0003600.parameters.status.statut.pompeFiltrationPilote2424.oui'
              | translate)
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.pompeFiltrationFonctionEntreeAsserviCommand'
            | translate
        "
        [value]="getValue('fsSPompeFiltrationFonctionEntreeAsservi') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsserviePrioriteElectrolyseElectrolyseurStandard'
            | translate
        "
        [value]="
          getValue(
            'fsSEntreeAsserviePrioriteElectrolyseElectrolyseurStandard'
          ) !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieAutoMaintienFiltrationElectrolyseurStandard'
            | translate
        "
        [value]="
          getValue(
            'fsSEntreeAsservieAutoMaintienFiltrationElectrolyseurStandard'
          ) !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionCL'
            | translate
        "
        [value]="
          getValue('fsSEntreeAsservieAutoMaintienFiltrationInjectionCL') !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          brandOverride(
            'P0003600.parameters.status.statut.entreeAsserviePrioriteElectrolyseElectrolyseurCellule'
              | translate
          )
        "
        [value]="
          getValue(
            'fsSEntreeAsserviePrioriteElectrolyseElectrolyseurCellule'
          ) !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          brandOverride(
            'P0003600.parameters.status.statut.entreeAsservieAutoMaintienFiltrationElectrolyseurCellule'
              | translate
          )
        "
        [value]="
          getValue(
            'fsSEntreeAsservieAutoMaintienFiltrationElectrolyseurCellule'
          ) !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionPH'
            | translate
        "
        [value]="
          getValue('fsSEntreeAsservieAutoMaintienFiltrationInjectionPH') !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionPAC'
            | translate
        "
        [value]="
          getValue('fsSEntreeAsservieAutoMaintienFiltrationInjectionPAC') !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsserviePrioriteFiltrationInjectionPAC'
            | translate
        "
        [value]="getValue('fsSEntreeAsserviFonctionPrioritePac') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionPACWp'
            | translate
        "
        [value]="getValue('fsSEntreeAsserviFonctionAutoMaintienPacWp') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsserviePrioriteFiltrationInjectionPACWp'
            | translate
        "
        [value]="getValue('fsSEntreeAsserviFonctionPrioritePacWp') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieAutoMaintienFiltrationInjectionPACPoly'
            | translate
        "
        [value]="getValue('fsSEntreeAsserviFonctionAutoMaintienPacPoly') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsserviePrioriteFiltrationInjectionPACPoly'
            | translate
        "
        [value]="getValue('fsSEntreeAsserviFonctionPrioritePacPoly') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieRedemarrageEclairageStandard'
            | translate
        "
        [value]="
          getValue('fsSEntreeAsservieRedemarrageEclairageStandard') !== 0
        "
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieRedemarrageEclairageTunable'
            | translate
        "
        [value]="getValue('fsSEntreeAsservieRedemarrageEclairageTunable') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsserviePrioriteRobot'
            | translate
        "
        [value]="getValue('fsSEntreeAsserviePrioriteRobot') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieAutoMaintienRobot'
            | translate
        "
        [value]="getValue('fsSEntreeAsservieAutoMaintienRobot') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieArretFiltrationVolet24'
            | translate
        "
        [value]="getValue('fsSEntreeAsserviArretFiltrationVolet24') !== 0"
      />

      <app-display-rubrique-status-on-off
        [title]="
          'P0003600.parameters.status.statut.entreeAsservieArretFiltrationVolet230'
            | translate
        "
        [value]="getValue('fsSEntreeAsserviArretFiltrationVolet230') !== 0"
      />
    </div>
  </app-collapse>
}

<!-- Section Produit -->
<app-collapse
  [title]="'P0003600.parameters.status.rubrique.produit' | translate"
  [warning]="
    getValue('fsSEtatProtectionMagnetique') === 1 ||
    getValue('fsSEtatProtectionThermique') === 1 ||
    presenceProduit === 2
  "
>
  <div slot="contenu">
    <app-display-rubrique-status-with-warning-and-cta
      [title]="
        'P0003600.parameters.status.statut.etatDeLaProtectionMagnetique'
          | translate
      "
      [warning]="getValue('fsSEtatProtectionMagnetique') === 1"
      [ctaText]="
        'P0003600.parameters.status.statut.etatDeLaProtectionMagnetique.reset'
          | translate
      "
      [notWarning]="
        'P0003600.parameters.status.statut.etatDeLaProtectionMagnetique.armed'
          | translate
      "
      (onPress)="resetProtectionMagnetique()"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003600.parameters.status.ResetProtectionRapide' | translate"
        [value]="
          getValue('fsSCompteurResetManuelProtectionMagnetique').toString()
        "
      />
    }

    <app-display-rubrique-status-with-warning-and-cta
      [title]="
        'P0003600.parameters.status.statut.etatDeLaProtectionThermique'
          | translate
      "
      [warning]="getValue('fsSEtatProtectionThermique') === 1"
      [notWarning]="
        'P0003600.parameters.status.statut.etatDeLaProtectionMagnetique.armed'
          | translate
      "
      [ctaText]="
        'P0003600.parameters.status.statut.etatDeLaProtectionThermique.reset'
          | translate
      "
      (onPress)="resetProtectionThermique()"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="'P0003600.parameters.status.ResetProtectionLente' | translate"
        [value]="
          getValue('fsSCompteurResetManuelProtectionThermique').toString()
        "
      />
    }

    <app-display-rubrique-status
      [title]="'P0003600.parameters.status.statut.tensionSecteur' | translate"
      [value]="getValue('fsSTensionSecteur') + ' V'"
    />

    <app-display-rubrique-status-with-warning
      [title]="
        'P0003600.parameters.status.statut.presenceDuProduit' | translate
      "
      [warning]="presenceProduit !== 1"
      [icon]="'fa-exclamation-triangle'"
      [text]="
        'P0003600.parameters.status.statut.presenceDuProduit.ok' | translate
      "
    />

    <app-display-rubrique-status
      [title]="'P0003600.parameters.status.statut.tempsSousTension' | translate"
      [value]="transformHourToDayHourLocal(getValue('fsSTempsSousTension'))"
    />

    @if (isSupportTechnique()) {
      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.nombreDeCommutationDuRelais'
            | translate
        "
        [value]="getValue('fsSNombreCommutationRelais').toString()"
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.compteurPuissanceActiveTotale'
            | translate
        "
        [value]="getValue('fsSCompteurPuissanceActiveTotale') + ' Wh'"
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.compteurAmpereHeure' | translate
        "
        [value]="getValue('fsSCompteurAmpereHeure') + ' Ah'"
      />

      <app-display-rubrique-status-on-off
        [title]="'P0003600.parameters.status.statut.etatDuBouton' | translate"
        [value]="getValue('fsSEtatBouton') !== 0"
      />

      <app-display-rubrique-status
        [title]="
          'P0003600.parameters.status.statut.compteurDuBouton' | translate
        "
        [value]="getValue('fsSCompteurBouton').toString()"
      />
    }
  </div>
</app-collapse>
